import React from 'react';

export const Leaf = ({ attributes, children, leaf }: any) => {
  let result = children;
  // check if the given content is part of a source. if it is, then let's actually
  // find the source
  if (leaf.bold) {
    result = <strong>{result}</strong>;
  }

  if (leaf.code) {
    result = <code>{result}</code>;
  }

  if (leaf.italic) {
    result = <em>{result}</em>;
  }

  if (leaf.underline) {
    result = <u>{result}</u>;
  }

  return <span {...attributes}>{result}</span>;
};
